import SearchInput from 'components/Form/TextField/SearchField.cmp';
import FiltersDropdown from 'components/TaskAdvanceFilters/FiltersDropdown';
import { HeaderCnt } from 'pages/task/TaskListView/TaskListHeader/taskListHeader.style';
import TaskGroupByDropdown from 'pages/task/TaskListView/GroupByDropdown/TaskGroupByDropdown';
import ColumnSelectionDropdown from 'pages/task/TaskListView/ColumnSelectionDropdown/columnSelectionDropdown';
import { VisibilityButton } from 'pages/taskDashboard.style';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ExportDropdown from 'pages/task/TaskListView/ExportDropdown';
import CustomButton from 'components/Button/CustomButton';
import AddIcon from '@mui/icons-material/Add';
import { setDialog } from 'store/actions/dialogActions';
import { HasPermission } from 'components/HasPermission';
import { useCustomPermission } from 'utils/CustomHooks/useCustomPermission';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'store/selectors';
import useTaskFilters from 'utils/CustomHooks/useTaskFilters/useTaskFilters';
import useTaskList from 'utils/CustomHooks/useTasksList';
import { useState, useMemo } from 'react';
import TaskActionsDropdown from './ActionDropdown';

interface TaskListHeaderPropTypes {
  disabledAdvanceFilters?: string[];
  forcedAdvanceFilters?: any[];
  isMainView: boolean;
}

function TaskCalendarHeader(props: TaskListHeaderPropTypes) {
  const { disabledAdvanceFilters, forcedAdvanceFilters, isMainView } = props;
  const { PERMISSIONS } = useCustomPermission();
  const filterData: any = useSelector(selectors.getTaskListFilters);
  const { handleSetAdvanceFiltersCommon } = useTaskFilters();
  const dispatch = useDispatch();
  const hideCompletedState: any = localStorage.getItem('hideCompleted');
  const hideCompletedStateParsed = !!JSON.parse(hideCompletedState);
  const [hideCompleted, setHideCompleted] = useState<boolean>(
    hideCompletedStateParsed,
  );

  // const setHideCompletedTask = () => {
  //   setHideCompleted(!hideCompleted);
  //   localStorage.setItem('hideCompleted', JSON.stringify(!hideCompleted));
  //   getCalendarTasks();
  // };

  const hiddenFilters = useMemo(() => {
    let hidden: any = '';
    if (disabledAdvanceFilters) {
      hidden = disabledAdvanceFilters.join(' ');
    }
    return hidden;
  }, [disabledAdvanceFilters]);

  const shouldShowAddButton = useMemo(() => {
    return (
      !forcedAdvanceFilters ||
      (forcedAdvanceFilters as any)?.filter(
        (f) => f.filterName === 'taskTypes' && f?.value?.includes('corrective'),
      )?.length === 0
    );
  }, [forcedAdvanceFilters]);

  return (
    <HeaderCnt>
      <div className={'lefCnt'}>
        <FiltersDropdown
          selectedFilters={filterData}
          onChange={(filters) =>
            handleSetAdvanceFiltersCommon(filters, forcedAdvanceFilters, {
              skipFilterSave: !isMainView,
            })
          }
          handleClearFilters={() =>
            handleSetAdvanceFiltersCommon(
              null,
              forcedAdvanceFilters ? forcedAdvanceFilters : null,
              { skipFilterSave: !isMainView },
            )
          }
          hideFilters={hiddenFilters}
        />
      </div>
      <div className={'rightCnt'}>
        {/* <VisibilityButton
          onClick={setHideCompletedTask}
          startIcon={
            hideCompleted ? (
              <VisibilityOffOutlinedIcon />
            ) : (
              <VisibilityOutlinedIcon />
            )
          }
        >
          {hideCompleted ? 'Show Completed' : 'Hide Completed'}
        </VisibilityButton> */}
        {shouldShowAddButton && (
          <HasPermission permissions={[PERMISSIONS.CAN_MANAGE_TASKS]}>
            <TaskActionsDropdown />
          </HasPermission>
        )}
      </div>
    </HeaderCnt>
  );
}

export default TaskCalendarHeader;
